import React, { Component } from 'react';
import TableModal from '../../../../UI/TableModal';
import Wrp from '../../../../../hoc/Wrp/Wrp';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import QuickCreateForms from '../../../../../Containers/LayoutContainer/QuickCreateForms';
import {
  clearSelectedMultiLookupAction,
  setSelectedMultiLookupAction,
  selectOrUnselect
} from '../../../../../store/actions/formBuilderActions';
import * as actions from '../../../../../store/actions';
import { isSet, getSelectedValueBasedOnField, IsJsonString } from '../../../../../Utils/CommonFunctions';
import {getFieldPropertiesFromGridList}  from '../../../../../Containers/LayoutContainer/LayoutCommonFunction';
import {callPOST} from '../../../../../Utils/ApiUtil';
import http from '../../../../../services/http';
// import convertToHtml from '../convertDraftjsToHtml';

class MultiLookupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
        isModalOpen:this.props.isModalOpen,
        isQuickAddModalOpen:false,
        status:null,
        page:this.props.page,
        lookup_layout:{},
        // selectedTableRecords:[],
        isConfirmPage:false,
        // isSetLookup:false,
    }
  }
  
   
  goBackMultiLookupList = () =>{
    this.MultiLookupModalWindowList(this.props.tableRecords.pagination,true);
    this.props.updateConfirmState(false);
    // this.setState({isConfirmPage:false})
  }
  unAssignSelectedMultiLookup = ()=>{
      this.props.clearSelectedMultiLookupAction();
      this.MultiLookupModalWindowList(this.props.tableRecords.pagination);
      // this.setState({isConfirmPage:false});
      this.props.updateConfirmState(false);
      this.props.selectOrUnselect(false)
      this.props.updateSuggestionLookup([]);
  }

  continueMultiLookup = (wthis) =>{
    const pagination={
        page:0,
        orderBy:'',
        perPage:10,
        direction:'ASC',
        search:''
    }
    this.continueMultiLookupPagination(pagination);
  }


  componentDidMount = ()=>{
     if(this.props.required_query===true && this.props.selectAll===false){
          console.log('check...');
          this.props.selectOrUnselect(this.props.required_query);
      }
      this.MultiLookupModalWindowList(this.props.tableRecords.pagination, true, true);
  }

  componentDidUpdate = (prevProps) => {
    if(prevProps.isModalOpen !== this.props.isModalOpen) {
      this.setState({isModalOpen: this.props.isModalOpen});
      if(this.props.isModalOpen===true){
        try {
          if(this.props.selectedValue===null){
            this.MultiLookupModalWindowList(this.props.tableRecords.pagination,true);
          }else{
            const selectedValueJSON = JSON.parse(this.props.selectedValue);
            this.MultiLookupModalWindowList(this.props.tableRecords.pagination,true,true);
          }
        }catch (e) {
          if(this.props.selectedValue==''){
            this.MultiLookupModalWindowList(this.props.tableRecords.pagination,true); 
          }else if(isSet(this.props.selectedMultiLookup[this.props.item.id],[]).length>0){
            this.props.updateTableRecords({
              ...this.props.tableRecords,
              tableData:{data:isSet(this.props.selectedMultiLookup[this.props.item.id],[]),status:200},
            })
          }
        }
       
      }
      
    }
    //  console.log('required_query',this.props.required_query,this.props.selectAll);
       
  }

  // componentDidUpdate = (prevProps) => {
  //     //console.log('MultiLookupWindowList1111');

  //     if(prevProps.isModalOpen !== this.props.isModalOpen) {
  //       this.setState({isModalOpen: this.props.isModalOpen});
  //       if( this.props.isModalOpen === true){
  //         this.MultiLookupModalWindowList(this.props.tableRecords.pagination, false, true);
  //       }
  //       if(this.props.isModalOpen===true && this.state.isQuickAddModalOpen===false){
  //         //console.log('MultiLookupWindowList333');
  //         this.MultiLookupModalWindowList(this.props.tableRecords.pagination, false, true);
  //       }
  //     }
  //   }

  continueMultiLookupPagination = (pagination)=>{
    const page = Number(pagination.page+1);
    const perPage = Number(pagination.perPage);
    const selectedMultiLookup = (isSet(this.props.selectedMultiLookup[this.props.item.id],[]));
    // console.log('selectedMultiLookup',selectedMultiLookup);
    const totalRecords = this.props.selectAll?this.props.tableRecords.pagination.totalRecords:selectedMultiLookup.length;
    pagination.totalRecords = totalRecords;
    let tableData = selectedMultiLookup;
    // console.log(pagination);
    var startIndex = (page-1) * perPage + 1;
    var endIndex = Math.min(startIndex + perPage - 1, totalRecords);
    // console.log(startIndex,endIndex);
    tableData = tableData.slice(startIndex-1,endIndex);
    if(this.props.selectAll){
      tableData=this.props.tableRecords.tableData.data
    }
    this.props.updateTableRecords({
      tableData:{data:tableData,status:200},
      tableHead:this.props.tableRecords.tableHead,
      pagination:{...pagination}
    })
    this.props.updateConfirmState(true);
    this.setState({status:200});
  }
  confirmSelectedMultiLookup = (selectedMultiLookup,isRefillOnEdit,isSubmit=0)=>{
    let lookupDataArr = [];
    let validation = [];
    let updatedRelatedWindowFields = (isSet(this.props.item.related_window_fields,[]).length>0)?
      isSet(this.props.item.related_window_fields[0],{}):
      [];
      let relatedWindowFieldsValue = [];
    selectedMultiLookup.map((item,itemIndex)=>{
        relatedWindowFieldsValue = [];
        let displayNameColumn = [];
        let defaultDisplay = [];
        updatedRelatedWindowFields = (isSet(this.props.item.related_window_fields,[]).length>0)?
      isSet(this.props.item.related_window_fields[0],{}):
      [];
        Object.entries(item.data).map(([fieldId,rowData],i) =>{
          if(isSet(rowData.item,null)!==null){
            updatedRelatedWindowFields = {
              ...updatedRelatedWindowFields,
              fieldGroups:[...updatedRelatedWindowFields.fieldGroups].map((sec)=>{
                return{
                  ...sec,
                  data:sec.data.map((itm)=>{
                    let updateItm = {...itm}
                    if(itm.id===rowData.item.id){
                      if(isSet(rowData.item.selectedValue,null)===null){
                        selectedMultiLookup[itemIndex].data[fieldId] = {
                          ...selectedMultiLookup[itemIndex].data[fieldId],
                          ['validation']:itm.label.blocks[0].text+' must be required'
                        }
                        validation.push(itm.label.blocks[0].text+' must be required');
                      }
                      updateItm = {
                        ...updateItm,
                        ...rowData.item
                      }
                    }
                    return updateItm;
                  })
                }
              })
            }
          }
            if(rowData.value!=='' && rowData.value!==undefined && rowData.value!=='-'){
              // const property  = getFieldPropertiesFromGridList(this.props.tableRecords.tableHead,rowData.tableDescId);
              const property  = getFieldPropertiesFromGridList(this.props.tableRecords.tableHead,fieldId);
              if(isSet(property.is_default_displayname,false)===true){
                defaultDisplay.push(rowData.value);
              }
              if(typeof rowData.value !== 'object')
              displayNameColumn.push(rowData.value); 
            }
           
            return rowData;
        })
        const endPos = (item.data.length<=2)? item.data.length:2;
        displayNameColumn = (defaultDisplay.length===0)?displayNameColumn.slice(0,endPos):defaultDisplay;
        lookupDataArr.push({
          label:displayNameColumn.join(' '),
          text:displayNameColumn.join(' '),
          id:item.rowId,
          value:item.rowId,
          ruleMapping:item.ruleMapping,
          data:item,
          related_window_fields:updatedRelatedWindowFields,
        })
        return item;
    });  
    // console.log('selectedMultiLookup',selectedMultiLookup);
    if(validation.length>0){
      this.props.failMessage('Sorry, there was something wrong with the given data. Please check and try again');
      return false;
    }
    if(this.props.updateInHidden || isSubmit===1){
      this.props.updateSuggestionLookup(lookupDataArr);
    }
    
    if(this.props.isModalEdit===true){
      this.goBackMultiLookupList(); 
    }else{
      if(selectedMultiLookup.length ===0){
        this.props.updateConfirmState(false);
        // this.setState({isSetLookup:true}); 
      }else{
        this.props.updateConfirmState(true);
        // this.setState({isSetLookup:true});
      }
      
    }          
    if(isRefillOnEdit===0){
      this.props.cancelMultiLoopupModalHandler(); 
    }
    this.props.updateTableRecords({
      ...this.props.tableRecords,
      tableData:{data:selectedMultiLookup,status:200},
    });
  }
  //MODAL POPUP 
  openQuickCreatePopup = () =>{
    this.setState({isQuickAddModalOpen:true});
  }
  //MODAL POPUP - CANCEL
  closeQuickCreatePopup = () =>{
    this.setState({isQuickAddModalOpen: false});
  }

  checkWithSelectedMultiLookup = (isconfirm=false)=>{
    const tableDataSel = this.props.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        isSet(this.props.selectedMultiLookup[this.props.item.id],[]).map((selectedItem)=>{
            if(selectedItem.rowId===item.rowId){
            const tableData = tableDataSel.tableData.data[index].data;
            tableDataSel.tableData.data[index].className=(this.props.isConfirmPage===false)?'selected':'';
            tableDataSel.tableData.data[index].isSelected=true;
            tableDataSel.tableData.data[index].data.Checkbox.checked=true;
            
            Object.entries(tableData).map(([key, column]) => {
              if(Object.keys(isSet(column.item,{})).length>0){
                tableDataSel.tableData.data[index].data[key] = selectedItem.data[key];
              }
            })
            }
        })  
    })
    this.props.updateTableRecords(tableDataSel);
    this.props.updateConfirmState(false);
  }
  selectAllTableData=(boolean=false,selectedRows=[])=>{
    // console.log('boolean',boolean);
    this.props.selectOrUnselect(boolean)
    if(boolean===true){
    this.selectAllCheckbox(boolean)
    }else{
      const tableDataSel = this.props.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        tableDataSel.tableData.data[index].className=(this.props.isConfirmPage===false)?'selected':'';
            tableDataSel.tableData.data[index].isSelected=boolean;
            tableDataSel.tableData.data[index].data.Checkbox.checked=boolean;
      })
      this.props.clearSelectedMultiLookupAction()
    }
}
  selectCheckbox=(e)=>{
    const val=e.target.checked
    // let isSelectAll =(this.state.tableRecords.tableHead[0].checked)?false:true;
    // console.log("aaa",val);  
    if(val===true){
      this.selectAllCheckbox(val)
    }else if(val===false){
      const tableDataSel = this.props.tableRecords;
      tableDataSel.tableData.data.map((item,index)=>{
        tableDataSel.tableData.data[index].className=(this.props.isConfirmPage===false)?'selected':'';
            tableDataSel.tableData.data[index].isSelected=false;
            tableDataSel.tableData.data[index].data.Checkbox.checked=false;
            this.props.removeSelectedMultiLookupAction(tableDataSel.tableData.data[index].rowId,this.props.item.id);
      })
      // this.props.clearSelectedMultiLookupAction()
      this.props.selectOrUnselect(false)
    }
  }
  selectAllCheckbox=(isChecked)=>{
    // let isChecked = e.target.checked;
    const newTableRecord = this.props.tableRecords;
    let hasValidation =false;
    let selectedCnt =0;
    newTableRecord.tableData.data.map((item,index)=>{
      const tableData = newTableRecord.tableData.data[index].data;
      let validation=[];
       Object.entries(tableData).map(([key, column]) => {
          if(Object.keys(isSet(column.item,{})).length>0){
            if(isSet(column.item.selectedValue,null)===null){
              validation.push(column.item.label.blocks[0].text+' must be required');
            }
          }
        })
        if(validation.length>0 && isChecked===true){
          this.props.failMessage(validation.join('</br>'));
          hasValidation = true; 
           return false;
        }
        if(tableData.Checkbox.checked!==isChecked){
          newTableRecord.tableData.data[index].className=(this.props.isConfirmPage===false)?'selected':'';
         newTableRecord.tableData.data[index].isSelected=true;
          newTableRecord.tableData.data[index].data.Checkbox.checked=isChecked;
           if(isChecked===true){
              selectedCnt++;
             this.props.addSelectedMultiLookupAction(newTableRecord.tableData.data[index],this.props.item.id);
            }else{
              this.props.removeSelectedMultiLookupAction(newTableRecord.tableData.data[index].rowId,this.props.item.id);
            }
            Object.entries(tableData).map(([key, column]) => {
              if(Object.keys(isSet(column.item,{})).length>0){
                  newTableRecord.tableData.data[index].data[key] = item.data[key];
              }  
            })
         }
     })
    if(isChecked===true && hasValidation===false){
      newTableRecord.tableHead[0].checked=true;
     }
    if(isChecked===false){
      newTableRecord.tableHead[0].checked=false;
    }  
    const isSelectedall = newTableRecord.pagination.totalRecords==(selectedCnt+Number(isSet(this.props.selectedMultiLookup[this.props.item.id],[]).length,isChecked));
    
    if(isSelectedall===true && this.props.isConfirmPage===false){
      this.props.selectOrUnselect(true);
    }
    this.props.updateTableRecords(newTableRecord)
  }
 

  setSelectedMultiLookupForUpdate = (tableData)=>{  
    try {
      if(this.props.selectedValue!==undefined && IsJsonString(this.props.selectedValue)){
      let selectedValueJSON = JSON.parse(this.props.selectedValue);
        if (selectedValueJSON.length > 0) {
          let selectedData = selectedValueJSON.map(sel => {
            const matchedRow = tableData.find(row => row.meta_table_id === sel.id);
            return {
              ...sel,
              fieldGroups: [
                {
                  type: sel.fieldGroups?.[0]?.type || "section",
                  data: matchedRow?.fields || []
                }
              ]
            };
          });
        this.iterateAndSetTableData(this.props.tableRecords.tableHead,selectedData,{
          header:{
            checked:true,
            isShow:true,
            isSelected:true,
            name:'windowCheckbox'
          },
          headerKey:'Checkbox'
         },selectedValueJSON.length,1);
      }
        }else{
          this.checkWithSelectedMultiLookup();
        }
    }catch (e) {
      console.log(e);
        
    }
  }
 


  // 
  onChangeRelatedField = (rowId,columnId,updateItem,e,inputType)=>{
    const tableRecords = this.props.tableRecords;
    let tableDataSel = {...tableRecords}
      tableDataSel.tableData.data.map((item,index)=>{
        if(item.rowId===rowId){
          let updateGroups = tableDataSel.tableData.data[index].data[columnId].item;
          let fieldValue;
          if(inputType==='PickList'){
            fieldValue = e; 
          }else if(inputType==='CheckBoxes'){
            fieldValue = e.target.checked;
          }else if(inputType==='MultiSelect'){
            let MultiSelectValue = [];
            e = (e===null)?[]:e;
            e.map((item)=>{
              MultiSelectValue.push(item.id);
              return item;
            }); 
            fieldValue = MultiSelectValue.join(',');
          }else if(inputType==='exchangeRate' || inputType==='phoneNumber' || inputType==='Lookup' || inputType==='number' || inputType==='MultiLookup' || inputType==='date' || inputType==='Files' || inputType==='currencyType' || inputType==='Reminder'){
            fieldValue = e;
          }else if(e){
            fieldValue = e.target.value;
          }
          let addedObj = {};
          if(inputType==='currencyType'){
            addedObj = {
              ...addedObj,
              ['currency_code']:fieldValue
            }
          }else if(inputType==='exchangeRate'){
            addedObj = {
              ...addedObj,
              ['exchange_rate']:fieldValue
            }
          }else if(inputType==='date'){ 
            addedObj = {
              ...addedObj,
              ['system_datetime_format']:fieldValue.systemFormat,
              ['selectedValue']:fieldValue.userFormat,
            }
          }else if(inputType==='Files'){
            addedObj = {
              ...addedObj,
              ['files']:fieldValue
            }
          }else if(inputType==='Reminder'){
            addedObj = {
              ...addedObj,
              ['reminder']:fieldValue
            }
          }else if(inputType==='Lookup' || inputType==='MultiLookup'){
            addedObj = {
              ...addedObj,
              ['selectedValue']:fieldValue.selectedValue,
              ['displayValue']:fieldValue.displayValue,
            }
          }else{
            addedObj = {
              ...addedObj,
              ['selectedValue']:fieldValue
            }
          }
          tableDataSel.tableData.data[index].data[columnId] = {
            ...tableDataSel.tableData.data[index].data[columnId],
            ['item']:{
              ...updateGroups,
              ...addedObj
            },
            validation:''
          }
        }
      });
      this.props.updateTableRecords(tableDataSel);
  }
updateRelatedWindowValues=(tableData)=>{
  const { item } = this.props;
    const { related_window_fields } = item;

    if (!related_window_fields || related_window_fields.length === 0) return;

    const updatedData = tableData.map((row, index) => {
      let fieldsRow = { ...row.data };
      const meta_table_id = row.rowId;

      related_window_fields.forEach((grp, grpIdx) => {
        if (grpIdx > 0) return;
        (grp.fieldGroups || []).forEach(sec => {
          (sec.data || []).forEach(rfield => {
            if (rfield.linking_window_field === true || rfield.element === "MultiLookup") return;
            const fieldId = rfield.id;
            if (fieldId) {
              fieldsRow[fieldId] = {
                className: "",
                item: {
                  ...rfield,
                  selectedValue: "",
                  attrFieldId: `${index}_${fieldId}`
                },
                section: sec,
                changeHandler: (u, e, t) =>
                  this.onChangeRelatedField(meta_table_id, fieldId, u, e, t)
              };
            }
          });
        });
      });

      return {
        ...row,
        data: fieldsRow
      };
    });

    this.props.updateTableRecords({
      ...this.props.tableRecords,
      tableData: { data: updatedData, status: 200 }
    });
  }
    iterateAndSetTableData = (tablehead,content,headAction,totalRecords,isRefillOnEdit=0,layout_rule_map={})=>{
      const {item} = this.props;
      const {related_window_fields} = item;
      let updateTableData = [];
      let fieldsRow;
      content.map((contentData)=>{
        fieldsRow = {}
          fieldsRow = {
            ...fieldsRow,
            [headAction.headerKey]:{...headAction.header}
          };
          fieldsRow = {
            ...fieldsRow,
            ['Checkbox']:{
              checked: (isRefillOnEdit===1) || this.props.selectAll?true:false,
              columnId: "checkbox",
              isShow: true,
              name: "windowCheckbox",
              changeHandler:()=>this.props.onChangeSelectLookup(meta_table_id),
            }
        }
          tablehead.map((column,headIndex)=>{
            if(headIndex>0){
              fieldsRow = {
                ...fieldsRow,
                [column.columnId]:{
                  className:'',
                  value:''
                },
              } 
            }
          });
          
          
          // Optimized record-list returns fields[] with fieldGroups:[]; prefer non-empty fieldGroups only
          if(Array.isArray(contentData.fieldGroups) && contentData.fieldGroups.length > 0){
            contentData.fieldGroups.map((section)=>{
              section.data.map((item,itemIndex)=>{
                      fieldsRow = {
                          ...fieldsRow,
                          [item.id || item.table_descriptor_id]:{
                              tableDescId:item.id || item.table_descriptor_id,
                              label:item.label || item.label.blocks[0].text,
                              className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                              value:getSelectedValueBasedOnField(item),
                              clickHandler:()=>this.props.onChangeSelectLookup(meta_table_id),
                          }
                      }
              })
            });
          }else if(Array.isArray(contentData.fields)){
            contentData.fields.map((item,itemIndex)=>{
              tablehead = [...tablehead].map((column)=>{
                if(item.table_descriptor_id===column.columnId){
                  let dataType = '';
                  if(item.element_type === 'Barcode') {
                    dataType = 'Barcode';
                  }else if(item.element_type==='Image' && item.files.length===0) {
                    dataType = 'Image';
                  }else if(item.element_type==='CheckBoxes') {
                    dataType = 'Others';
                  }else if(item.element_type!=='Image') {
                    dataType = 'HyperLink';
                  }else {
                    dataType = 'Image';
                  }
                  column.type = dataType;
                }
                return column;
              });
              item.selectedValue = item.value;
              item.element = (item.element_type==='PickList' || item.element_type==='MultiSelect' || item.element_type==='File'  || (item.element_type==='Image' && item.files.length===0))?'TextInput':item.element_type;
              item.options = [];
              const selectedValue = getSelectedValueBasedOnField(item);
              if(selectedValue!=='' && selectedValue!==undefined && selectedValue!==null && selectedValue!=='-'){
                fieldsRow = {
                  ...fieldsRow,
                  [item.table_descriptor_id]:{
                        className:(itemIndex<=1)?'primary_color cursor-pointer':'cursor-pointer',
                        isDefaultDisplay:false,//item.is_default_displayname,
                        value:selectedValue,
                        tableDescId:item.table_descriptor_id,
                        label:item.label,
                        clickHandler:()=>this.props.onChangeSelectLookup(meta_table_id),
                  }
                }
              }
          });
          }
          // if(isRefillOnEdit===0 && isSet(item.has_related_window,false)===true){
          //   isSet(related_window_fields,[]).map((rltGrp,rltIndex)=>{
          //     if(rltIndex>0){ return false; }
          //     isSet(isSet(rltGrp,{fieldGroups:[]}).fieldGroups,[]).map((sec)=>{
          //       sec.data.map((itm)=>{
          //         if(itm.linking_window_field ===true || itm.element==='MultiLookup'){ 
          //           return false;
          //         }
          //          fieldsRow = {
          //         ...fieldsRow,
          //         [itm.id]:{
          //             className:'',
          //             item:{...itm,selectedValue:'',attrFieldId:updateTableData.length+'_'+itm.id},
          //             section:sec,
          //             changeHandler:(updateItm,e,inputType)=>this.onChangeRelatedField(meta_table_id,itm.id,updateItm,e,inputType)
          //         }
          //       }
          //       })
          //     })
          //   })
          // }
         
        const meta_table_id = (contentData.metaTableId)?contentData.metaTableId:contentData.meta_table_id
        updateTableData.push({
            className:(isRefillOnEdit===1)?'checked':'',
            rowId:meta_table_id,
            ruleMapping:isSet(layout_rule_map[meta_table_id],{}),
            data:fieldsRow
        })
      });
      this.props.updateTableRecords({
        tableData:{data:updateTableData,status:200},
        tableHead:tablehead,
        pagination:{...this.props.tableRecords.pagination,totalRecords:totalRecords}
      });
      
      this.setState({status:200});
    if (isRefillOnEdit === 0 && item.has_related_window === true) {
      setTimeout(() => {
        this.updateRelatedWindowValues(updateTableData);
      }, 50);
    }
      if(isRefillOnEdit===1){
        this.props.setSelectedMultiLookupAction(updateTableData,this.props.item.id);
        setTimeout(() => {
          this.confirmSelectedMultiLookup(updateTableData,isRefillOnEdit);
        },100)
      }
    } 
  MultiLookupModalWindowList =(pagination,loader=false,isEditPage=false) =>{
    const windowName = this.props.windowName;
    const params = this.props.match.params;
    // my code 07 - Avoid subform exception
    const {item} = this.props;    
    if(item.is_subform===true){ return false; }
    // endss
    const {related_window_fields} = item;
    const page = pagination.page; 
    const orderBy = pagination.orderBy; 
    const perPage = pagination.perPage; 
    const direction = pagination.direction; 
    const search = pagination.search;
    this.props.updateTableRecords({
      ...this.props.tableRecords,
      pagination:pagination
    });
    if(loader===true){ this.props.Loader(); }
    const queryString = '?query='+search+'&page='+page+'&orderBy='+orderBy+'&size='+perPage+'&direction='+direction+'&parent_layout_id='+params.layoutId+'&parent_window_id='+params.windowId;
    const listDataPromise = callPOST('table-data-engine/' + windowName + '/metatable/record-list/active' + queryString, {});
    const listCountPromise = callPOST('table-data-engine/' + windowName + '/metatable/record-listCount/active' + queryString, {});
    Promise.all([listCountPromise, listDataPromise])
    .then(([resCount, res]) => {
      if(loader===true){ this.props.Loader(); }
      if(res.status===200){ 
        const response = res.data;
        const responseCount = resCount.data;
        if(response.code===200){
          const resData = response.data;
          this.setState({lookup_layout:{
            lookupLayoutId:resData.lookup_layout_id,
            moduleId:resData.module_id,
            windowId:resData.window_id,
            windowName:windowName
          }});
          
          let tablehead = [
            {
              name:'',
              type:"Checkbox",
              columnName:"",
              isShow:true,
              clickHandler : (e)=> this.selectCheckbox(e),
              checked:false,
              attributes:{style:{width: "30px"}}
            }
          ]
          const layout_rule_map = isSet(response.data.layout_rule_map,{});
          response.data.grid_list.map((header)=>{
            tablehead.push({
              ...header,
              name:header.display_name,
              type:"HyperLink",
              columnId:header.table_descriptor_id,
              isShow:header.is_show,
            });
          }) 
          if(isSet(item.has_related_window,false)===true){
            isSet(related_window_fields,[]).map((rltGrp,rltIndex)=>{
              if(rltIndex>0){ return false; }
              // if(rltGrp==null){return false; }
              isSet(isSet(rltGrp,{fieldGroups:[]}).fieldGroups,[]).map((sec)=>{
                sec.data.map((fieldItm)=>{
                  if(fieldItm.linking_window_field ===true || fieldItm.element==='MultiLookup'){ // || fieldItm.element==='Lookup'
                    return false;
                  }
                  tablehead.push({ 
                    name:fieldItm.label.blocks[0].text,
                    type:'InputElement',
                    columnId:fieldItm.id,
                    isShow:true,
                    attributes:{style:{minWidth:'250px'}}
                  });
                })
              })
            })
          }
          let totalRecords = responseCount.data.value_list.total_elements;  
          let tableDataContent=response.data.value_list.content ;
          this.iterateAndSetTableData(tablehead,tableDataContent,{
            header:{
              checked:false,
              name:'windowCheckbox',
              isShow:true,
            },
            headerKey:'Checkbox'
          },totalRecords,0,layout_rule_map);
          if(isEditPage===true){
            this.setSelectedMultiLookupForUpdate(tableDataContent); 
          }else if(this.props.isConfirmPage===false){
            this.checkWithSelectedMultiLookup();
          }
          
        }else{
          const totalRecords = 0;//response.data.totalElements;
          this.props.updateTableRecords({
            tableData:{data:[],status:400},
            tableHead:this.props.tableRecords.tableHead ,
            pagination:{...this.props.tableRecords.pagination,totalRecords:totalRecords}
          })
          this.setState({status:200});
        }
      }
    }, (error) => {
      console.log(error);
      this.props.failMessage("Something went wrong...");
      this.props.Loader(false);
      
    })
  }

  render () {
    const ModalTitle = (this.props.isConfirmPage===false)?"Assign "+this.props.windowName:'Assign '+this.props.windowName+'';
    const modalType = 'tableList';
    const modalButtonList = [{
              attributes:{
                className:"btn btn btn-cancel mr-2 cursor-pointer",
                "data-dismiss":"modal",
                "id":"closeAddNewRoleModal",
              },
              clickHandler:this.props.cancelMultiLoopupModalHandler,
              name:"Cancel"
          }]
          if(this.props.isConfirmPage===true){
            modalButtonList.push({
              clickHandler:this.unAssignSelectedMultiLookup,
              attributes:{
                className:"btn secondary_bg cursor-pointer",
              },
              name:"Unassign All "+this.props.windowName
            })
          }else{
            modalButtonList.push({
              clickHandler:this.openQuickCreatePopup,
              type:'add',
              attributes:{
                className:"btn primary_bg cursor-pointer",
              },
              name:"Add "+this.props.windowName
            })
          } 
          let FooterButtonList;
          if(this.props.isConfirmPage===false){
             FooterButtonList = [  
                {
                  attributes:{
                    className:"btn btn btn-cancel",
                    "data-dismiss":"modal",
                    "id":"closeAddNewRoleModal",
                  },
                  clickHandler:this.continueMultiLookup,
                  name:"Continue",
                  disabled:(isSet(this.props.selectedMultiLookup[this.props.item.id],[]).length>0?false:true),
                }
              ];
          }else{
             FooterButtonList = [
                {
                    attributes:{
                      className:"btn border-default btn-border mr-2 cursor-pointer",
                    },
                    // style:{display:(this.props.isModalEdit===true)?'nonee':'none'},
                    clickHandler:this.goBackMultiLookupList,
                    name:"Add More"
                  },  
                {
                  attributes:{
                    className:"btn primary_bg cursor-pointer",
                    "data-dismiss":"modal",
                    "id":"closeAddNewRoleModal",
                  },
                  clickHandler:this.confirmSelectedMultiLookup.bind(this,isSet(this.props.selectedMultiLookup[this.props.item.id],[]),0,1),
                  name:"Confirm"
                }
              ];
          }
        // console.log('this.props.item.required_query',this.props.item.required_query);
        return (
          <Wrp>
            <TableModal 
              isModalOpen={this.props.isModalOpen}
              title={ModalTitle}
              modalType={modalType}
              buttonList={modalButtonList}
              tableRecords={this.props.tableRecords}
              FooterButtonList={FooterButtonList}
              recordsChangeHandler={
                this.props.selectAll?this.MultiLookupModalWindowList:
                  (this.props.isConfirmPage===false)?
                    this.MultiLookupModalWindowList
                  : this.continueMultiLookupPagination
              }
              windowName={this.props.windowName}
              selectedMultiLookupCount = {(this.props.selectAll===true)?this.props.tableRecords.pagination.totalRecords:isSet(this.props.selectedMultiLookup[this.props.item.id],[]).length}
              isConfirmPage={this.props.isConfirmPage}
              selectAllTableData={this.selectAllTableData}
              selectAll={this.props.selectAll}
             />
             {(this.state.isQuickAddModalOpen===true)?
                <QuickCreateForms 
                  succMessage={this.props.succMessage}
                  failMessage={this.props.failMessage}  
                  Loader={this.props.Loader}
                  closeQuickCreatePopup={this.closeQuickCreatePopup}
                  isQuickAddModalOpen={this.state.isQuickAddModalOpen}
                  lookup_layout={this.state.lookup_layout}
                  goBackLookupList={this.goBackMultiLookupList}
                />  
             :''}
              
          </Wrp>   
        )
    }
}
MultiLookupModal.defaultProps={
  isModalOpen : false
}
const mapDispatchToProps = dispatch => {
  return {
  Loader : (bool) => dispatch(actions.loader(bool)),
  succMessage : (msg) => dispatch(actions.succMessage(msg)),
  failMessage : (msg) => dispatch(actions.failMessage(msg)),  
  clearSelectedMultiLookupAction:()=>dispatch(clearSelectedMultiLookupAction()),
  setSelectedMultiLookupAction:(data,id)=>dispatch(setSelectedMultiLookupAction(data,id)),
  selectOrUnselect:(obj)=>dispatch(selectOrUnselect(obj))
  };
}
const mapStateToProps = (state,props) => { 
  return {
    selectedMultiLookup : state.formBuilder.selectedMultiLookup,
    selectAll:state.formBuilder.selectAll,
  };
}
export default
  connect(
    mapStateToProps, 
    mapDispatchToProps
  )(withRouter(MultiLookupModal));